import AuthService from './auth.service';

export default class FreemiumSessionService {
    constructor() {
        this.authService = new AuthService();
    }

    async bootstrap() {
        try {
            const response = await fetch('/api/freemium/session', {
                method: 'GET',
                credentials: 'same-origin'
            });
            if (!response.ok) return { active: false, unavailable: true };

            const session = await response.json();
            if (session.active === true && this.authService.isAuthenticated()) return session;
            this.authService.setFreemiumSessionActive(session.active === true);
            return session;
        } catch (error) {
            return { active: false, unavailable: true };
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/freemium-session.service.js